import UdeskLocales from 'UdeskLocales';
import React from 'react';
import './style.scss';

interface TemplateProps {}

const Template: React.FC<TemplateProps> = (props) => {
    const { children } = props;

    return (
        <div
            className="udesk-qa-web-login-page-jusihong"
            style={{
                backgroundImage: `url(/static/images/jusihong-login-page-bg.png)`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <div className="left">
                <div
                    style={{
                        width: 340,
                        height: 270,
                        backgroundImage: `url(/static/images/jusihong-login-page-logo1.png)`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                    }}
                ></div>
            </div>

            <div className="right">
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            borderRadius: 20,
                            height: 200,
                            width: '70%',
                            backgroundColor: '#fff',
                            position: 'relative',
                            padding: '0px 40px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'stretch',
                        }}
                    >
                        <div
                            style={{
                                width: 200,
                                height: 60,
                                backgroundImage: `url(/static/images/jusihong-login-page-logo2.png)`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                position: 'absolute',
                                top: -46,
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                        ></div>

                        <div
                            style={{
                                textAlign: 'center',
                                fontSize: 18,
                                fontWeight: 'bold',
                                marginTop: 40,
                            }}
                        >
                            {/* 欢迎登录 */}
                            {UdeskLocales['current'].pages.login.components.layout.welcomeToLogin}
                        </div>

                        {children}

                        <div
                            style={{
                                position: 'absolute',
                                bottom: 8,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: 100,
                                height: 20,
                                backgroundImage: `url(/static/images/jusihong-login-page-logo3.png)`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                            }}
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Template;
